import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ProjectCard } from '../../components/Cards';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../Sanityclient';
import './Work.scss';
const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
`;
const Work = (setOpenModal, openModal) => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  useEffect(() => {
    const query = '*[_type == "works"]';
    client
      .fetch(query)
      .then((data) => {
        console.log(data);
        setWorks(data);
        setFilterWork(data);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        My Creative <span>Projects</span> Section
      </h2>

      <div className="app__work-filter">
        {['Apps/Websites', 'Games', 'Software', 'All'].map((item, index) => (
          <motion.div
            key={index}
            onClick={() => handleWorkFilter(item)}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.1, type: 'tween' }}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </motion.div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <CardContainer key={index}>
            <ProjectCard
              work={work}
              openModal={openModal}
              setOpenModal={setOpenModal}
            />
          </CardContainer>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg',
);
